/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import DataTable from 'react-data-table-component'
import {Link} from 'react-router-dom'
import axios from 'axios'
import apiConnect from '../../api/apiConnect'
import {useParams} from 'react-router-dom'
import Swal from 'sweetalert2'

import {ParameterNameWidget} from './component/ParameterNameWidget'
import {ParameterChartWidget} from './component/ParameterChartWidget'
import {ParameterValueWidget} from './component/ParameterValueWidget'
import {ParameterLimitWidget} from './component/ParameterLimitWidget'
import {ParameterRocWidget} from './component/ParameterRocWidget'

import {LimitHistoryModal} from './component/LimitHistoryModal'
import {LimitROCHistoryModal} from './component/LimitROCHistoryModal'

const ParameterDetail = () => {
  const parameterId = useParams().parameterId
  const deviceId = useParams().deviceId
  const [parameterData, setParameterData] = useState({})
  const [deviceData, setDeviceData] = useState({})
  const [chartData, setChartData] = useState([]) // State สำหรับข้อมูลกราฟ
  const [chartTotal, setChartTotal] = useState(null)
  const [chartStep, setChartStep] = useState('6hr')

  const [showMadalLimitHistory, setShowMadalLimitHistory] = useState(false)
  const [showMadalLimitROCHistory, setShowMadalLimitROCHistory] = useState(false)

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await apiConnect.get(`/v1/parameters/${parameterId}`)
        setParameterData(response.data.data)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
    fetchData()
  }, [])

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await apiConnect.get(`/v1/devices/by-device-id/${deviceId}`)
        setDeviceData(response.data)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
    fetchData()
  }, [])

  // useEffect(() => {
  //   async function fetchData() {
  //     const apiUrl = `${process.env.REACT_APP_API_URL}/v1/parameters/${parameterId}/latest/5`
  //     try {
  //       const response = await axios.get(apiUrl, {
  //         headers: {
  //           Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN_KEY}`,
  //         },
  //       })
  //       const data = response.data.data.sort((a, b) => b.t - a.t)
  //       setChartData(data)
  //     } catch (error) {
  //       console.error('Error fetching data:', error)
  //     }
  //   }
  //   fetchData()
  // }, [])

  useEffect(() => {
    async function fetchData() {
      setChartTotal(null)
      setChartData([]) // รีเซ็ตข้อมูลกราฟก่อนทำการดึงข้อมูลใหม่
      const now = Math.floor(Date.now() / 1000) // ปัจจุบันในหน่วยวินาที
      let endTime

      if (chartStep === '6hr') {
        endTime = now - 7 * 60 * 60
      } else if (chartStep === '1dayAvg') {
        endTime = now - 25 * 60 * 60
      } else if (chartStep === '7dayAvg') {
        endTime = now - 169 * 60 * 60
      }

      if (chartStep === '1dayAvg') {
        try {
          const response = await apiConnect.get(
            `/v1/parameters/${parameterId}/value/range-avg/${now}/${endTime}/one-per-1-hour`
          )
          const data = response.data.log.sort((a, b) => b.t - a.t)
          setChartData(data)
          setChartTotal(response.data.total)
        } catch (error) {
          console.error('Error fetching data:', error)
        }
      } else if (chartStep === '7dayAvg') {
        try {
          const response = await apiConnect.get(
            `/v1/parameters/${parameterId}/value/range-avg/${now}/${endTime}/one-per-1-hour`
          )
          const data = response.data.log.sort((a, b) => b.t - a.t)
          setChartData(data)
          setChartTotal(response.data.total)
        } catch (error) {
          console.error('Error fetching data:', error)
        }
      } else {
        try {
          const response = await apiConnect.get(
            `/v1/parameters/${parameterId}/value/range/${now}/${endTime}`
          )
          const data = response.data.data.sort((a, b) => b.t - a.t)
          setChartData(data)
        } catch (error) {
          console.error('Error fetching data:', error)
        }
      }
    }
    fetchData()
  }, [chartStep])

  return (
    <>
      <>
        <div className='d-flex flex-wrap flex-stack mb-6'>
          <h3 className='fw-bolder'>
            <Link to={`/device/${deviceId}`} className='btn btn-icon btn-secondary btn-sm me-5'>
              <i className='fas fa-arrow-left fs-4'></i>
            </Link>
            {parameterData?.name}{' '}
          </h3>

          <div className='d-flex my-2'>
            <ol className='breadcrumb text-muted fs-6 fw-bold'>
              <li className='breadcrumb-item pe-3'>
                <Link to={'/dashboard'} className='pe-3'>
                  Home
                </Link>
              </li>

              <li className='breadcrumb-item pe-3'>
                <Link to={`/device/${deviceId}`} className='pe-3'>
                  {deviceData?.name}
                </Link>
              </li>

              <li className='breadcrumb-item px-3 text-muted'>{parameterData?.name}</li>
            </ol>
          </div>
        </div>

        <div className='row g-3'>
          <div className='col-12 col-md-4'>
            <ParameterNameWidget parameterData={parameterData} />
            <ParameterValueWidget parameterData={parameterData} />

            <div className='row'>
              <div className='col-6'>
                <ParameterLimitWidget
                  parameterData={parameterData}
                  setShowMadalLimitHistory={setShowMadalLimitHistory}
                />
              </div>
              <div className='col-6'>
                <ParameterRocWidget
                  parameterData={parameterData}
                  setShowMadalLimitROCHistory={setShowMadalLimitROCHistory}
                />
              </div>
            </div>
          </div>
          <div className='col-12 col-md-8'>
            <ParameterChartWidget
              className='card-xl-stretch mb-xl-8'
              chartData={chartData}
              chartStep={chartStep}
              setChartStep={setChartStep}
              chartTotal={chartTotal}
            />
          </div>
        </div>

        <LimitHistoryModal
          showMadalLimitHistory={showMadalLimitHistory}
          setShowMadalLimitHistory={setShowMadalLimitHistory}
        />

        <LimitROCHistoryModal
          showMadalLimitROCHistory={showMadalLimitROCHistory}
          setShowMadalLimitROCHistory={setShowMadalLimitROCHistory}
        />

        {/* <div className='d-flex flex-wrap flex-stack mb-6'>
          <h3 className='fw-bolder'>
            Parameter Details : {deviceData?.name}{' '}
            {deviceData?.premium ? (
              <span className='badge badge-info'>Premium</span>
            ) : (
              <span className='badge badge-light'>Standard</span>
            )}
          </h3>

          <div className='d-flex my-2'>
            <ol className='breadcrumb text-muted fs-6 fw-bold'>
              <li className='breadcrumb-item pe-3'>
                <Link to={'/dashboard'} className='pe-3'>
                  Home
                </Link>
              </li>

              <li className='breadcrumb-item px-3 text-muted'>{deviceData?.name}</li>
            </ol>
          </div>
        </div>

        <div className='row'>
          <div className='col-12 card mb-5 mb-xl-10'>
            <div className='card-header border-0 pt-2'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bold fs-3 mb-1'>
                  Parameter ({combinedArray.length})
                </span>
              </h3>

              <Link to={`/create-new-parameter/${deviceId}`} className=' my-2'>
                <div className='btn btn-sm btn-primary'>Create new parameter</div>
              </Link>
            </div>
            <div className='card-body border-top py-3'>
              <div className='table-responsive'>
                <DataTable
                  columns={columns}
                  data={combinedArray}
                  pagination
                  paginationPerPage={20}
                  paginationRowsPerPageOptions={[20, 50, 100]}
                  keyField='parameterId'
                />
              </div>
            </div>
          </div>
        </div> */}
      </>
    </>
  )
}

export {ParameterDetail}

function getTimeFormat(timestamp) {
  const createdAt = new Date(timestamp * 1000)
  const formattedDate = createdAt.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })
  const formattedTime = createdAt.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  })
  const formattedDateTime = `${formattedDate} ${formattedTime}`
  return formattedDateTime
}
